import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';

type PublicPortfolioPageProps = {
  constrained?: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicPortfolioPage',
  props: {
    constrained: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { constrained: boolean };



const rootClass = computed(() => ({
  'public-portfolio-page': true,
  'public-portfolio-page--constrained': props.constrained,
}));

const innerClass = computed(() => ({
  'public-portfolio-page__inner': true,
  'public-portfolio-page__inner--constrained': props.constrained,
}));

return { __sfc: true,props, rootClass, innerClass }
}

})